import React, { useEffect } from 'react'
import { Icon } from '../..'
import { CollapseStyles as s } from './styles'

type Props = {
  'data-qa'?: string
  iconName?: string
  title: string
  children: React.ReactNode
  isOpen?: boolean
}

const Collapse: React.FC<Props> = (props: Props): JSX.Element => {
  const [isOpen, setIsOpen] = React.useState(false)

  useEffect(() => {
    setIsOpen(props.isOpen)
  }, [props.isOpen])

  return (
    <s.CollapseContainer isOpen={isOpen} data-qa={props['data-qa']}>
      <header
        onClick={() => setIsOpen(!isOpen)}
        data-qa={props['data-qa'] && `${props['data-qa']}-header`}
      >
        {props.iconName && <Icon name={props.iconName} />}
        <h3 className="title">{props.title}</h3>
        <Icon name={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
      </header>

      <article
        className={`${isOpen ? 'details' : ''} content`}
        data-qa={props['data-qa'] && `${props['data-qa']}-content`}
      >
        {isOpen && props.children}
      </article>
    </s.CollapseContainer>
  )
}

export default Collapse
